module.exports = __webpack_public_path__ + "img/administrativo.44b74d68.png";